import { createContext } from "react";
const UserPhotoIdContext = createContext();
export default UserPhotoIdContext;